import React, { useReducer, useEffect, useState } from 'react';

import {
  ContentAppLayout
} from 'clnt-common';

import {
  themes,
} from '#src';

import { siteData } from './data/siteData';

// NOTE: global.css is included in index.html as <link>

function App(props) {
  const { appContext, routes, route, getEnvVar, user } = props

  console.debug('App: begin');

  const useLayout = 'xl';
  const headers = siteData(getEnvVar, {type: 'headerOptions' });
  const footers = siteData(getEnvVar, {type: 'footerOptions' });

  return ContentAppLayout({ themes, getEnvVar, appContext, useLayout, routes, route, headers, footers, user });
}

export default App
